export default __webpack_public_path__ + "fonts/Gotham-Light.f2f5faa546eabe861306c20a93493b06.ttf";